import React, {Component} from 'react';
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';

import * as Cart from '../../utils/cartHelper';
import * as LocalStorage from '../../utils/localStorageHelper';
import * as GoogleAPI from '../../utils/googleApiHelper';
import * as UserActions from '../../actions/userActions';
import { validateLatLongForDelivery } from '../../components/commons/place-picker/PlacePicker';


class PlacePickerPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isDeliveryPermitted: false,
      showAlert: false,
      swalParams: {
        title: ''
      },
    }

    this.location = {
      lat: 34.0502,
      lng: -118.257
    }

    this.initMap = this.initMap.bind(this);
    this.setPlace = this.setPlace.bind(this);
    this.onPlaceChanged = this.onPlaceChanged.bind(this);
    this.validateDeliveryArea = this.validateDeliveryArea.bind(this);
  }

  componentDidMount() {

    const {location, match, deliveryPlace} = this.props;
    let googlePlace = deliveryPlace && deliveryPlace.geometry ? deliveryPlace : false;

    if(location.state && location.state.actionMode) {

      let newState = {actionMode: location.state.actionMode};
      if(location.state.actionMode === 'edit') {
        let placeToEdit = LocalStorage.get("edit_google_place");
        newState.place = location.state.place;
        newState.addressId = location.state.addressId;
        newState.place = placeToEdit;
      }
      this.setState(newState);
    }
    if(location.state.apartment) this.setState({apartment:location.state.apartment});


    if (deliveryPlace && deliveryPlace.geometry) {
      this.setState({place: deliveryPlace})
      let location = GoogleAPI.getLocationByPlace(deliveryPlace);
      this.location = location;
    }

    this.initMap();
    window.scrollTo(0, 0);
  }

  render() {
    const {place, isDeliveryPermitted, showAlert, swalParams, actionMode, deliveryValidationStatus} = this.state;

    let actionButtonText = 'Select Address';
    if(actionMode && actionMode === 'add') actionButtonText = 'Add Address';
    else if(actionMode && actionMode === 'edit') actionButtonText = 'Update Address';

    return (
      <div className="page place-picker-page">
        <div className="container">
          <h1 className="page-title">Select Delivery Address</h1>

          <div className="row">
            <div className="col-md-12">
              <input placeholder="Search address..." aria-label="Search address..." className="address-search-input" ref={(elem) => this.autocompleteElement = elem}/>
            </div>

            {place
              ? (
                <div className="width-100">
                <div className="col-md-12 info-row">
                    <input maxLength="12" aria-label="Apartment # (Optional)" placeholder="Apartment # (Optional)" className="form-control" value={this.state.apartment} onChange={(e) => this.setState({ apartment: e.target.value })} />
                    {this.state.apartment && this.state.apartment.length === 12 && <div className="error-text">Apartment No. should be less than 12 characters.</div>}
                </div>
                <div className="col-md-12 info-row">
                  <span className="label">Address:
                  </span>
                  <span className="value">{place.formatted_address}</span>
                  {deliveryValidationStatus && deliveryValidationStatus.status
                  && deliveryValidationStatus.time ?
                    <div>
                        <span className="text-info">{`* For this delivery address, we will need at least ${deliveryValidationStatus.timeDisplay} to deliver.`}
                        </span>
                    </div>
                    : null
                  }
                </div>
              </div>
              )
              : null
            }
            <div className={`col-md-12 ${place
              ? ''
              : 'invisible'}`}>
              <div className="address-map" ref={(elem) => this.mapElement = elem}></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="footer-buttons-container">
                <a href="#" className="button-back" onClick={() => this.props.history.goBack()}>Back</a>
                <a href="javascript:void(0)" 
                  className={`button-review-order ${isDeliveryPermitted ? '' : 'disabled'}`} 
                  onClick={() => isDeliveryPermitted ? this.setPlace(): null}
                >{actionButtonText}</a>
              </div>
            </div>
          </div>
        </div>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    )
  }

  initMap() {

    this.map = GoogleAPI.initMap(this.mapElement, {}, this.onPlaceChanged);
    this.marker = GoogleAPI.addMarker(this.map, this.location);
    GoogleAPI.addMarkerDragEvent(this.marker, this.onPlaceChanged);
    GoogleAPI.addMapClickEvent(this.map, this.onPlaceChanged);
    GoogleAPI.setAutocompleteService(this.autocompleteElement, this.onPlaceChanged);
  }

  onPlaceChanged(place) {
    if(place.name) {
      let placeName = place.name.trim();
      let placeNameExistence = place.formatted_address.indexOf(placeName);
  
      if (placeNameExistence !=0)
        place.formatted_address = place.name + ', ' + place.formatted_address;
    }
    
    let location = GoogleAPI.getLocationByPlace(place);
    GoogleAPI.updateMarker(this.map, this.marker, location);
    if (place && place.geometry) {
      const deliveryArea = GoogleAPI.checkAreaDeliverable(place.geometry.location);
      this.validateDeliveryArea(deliveryArea);
    }
    const deliveryValidationStatus = validateLatLongForDelivery(location, 'GIFT');
    this.setState({place, deliveryValidationStatus: {
        ...deliveryValidationStatus,
        time: deliveryValidationStatus.time > 12 ? deliveryValidationStatus.time: 0,
        // only used for normal deliveries in extended areas
        // intentionally changed to 2 business days
        // read JSDoc - validateLatLongForDelivery
        timeDisplay: deliveryValidationStatus.time < 12 ? '' : '2 days'
      }});
    
    this.autocompleteElement.value = place.formatted_address;
  }

  setPlace() {

    const {place, actionMode, addressId,apartment, area} = this.state;
    let latLng = GoogleAPI.getLocationByPlace(place);
    if (!place) {
      alert("Please select delivery address");
    }
    else {
      const country = GoogleAPI.extractFromAddress(place.address_components, 'country', 'short_name');
      const houseNumber = GoogleAPI.extractFromAddress(place.address_components,"street_number");
      const streetRoute = GoogleAPI.extractFromAddress(place.address_components,"route");
      let street = houseNumber && streetRoute ? `${houseNumber} ${streetRoute}` : null;
      street = street ? street : streetRoute;
      const city = GoogleAPI.extractFromAddress(place.address_components, 'locality');
      const state = GoogleAPI.extractFromAddress(place.address_components, 'administrative_area_level_1', 'short_name');
      const zip = GoogleAPI.extractFromAddress(place.address_components, 'postal_code');
      if (country !== 'US' && country !== 'United States') {
          this.setState({showAlert: true, swalParams: {
          title: 'Sorry, We dont deliver outside of the United States, please choose different location from map or you can search location',
          type: "error",
          showConfirmButton: false
        }});
        setTimeout(() => this.setState({showAlert: false}), 2000);
        return;
      }
      if(actionMode === 'add') {
        this.props.dispatch(UserActions.addUserAddress({
          description: place.formatted_address,
          loc: [latLng.lng, latLng.lat],
          nearestStore: area,
          street,
          city,
          state,
          zip,
          country,
          apartment
        }, response => {
          console.log("ADD_ADDRESS_RESPONSE", response);
          if(response.status) {
            let addresses = response.data;
            Cart.modifyCartAttribute(Cart.ATTRIBUTE_DELIVERY_ADDRESS, {address: addresses[addresses.length-1]});
            this.props.history.goBack();
          } else {
              this.setState({
                showAlert: true,
                swalParams: {
                  title:
                    response.data && response.data.message || "Something went wrong adding the address. Please try later.",
                  type: "error",
                  showConfirmButton: false,
                },
              });
          }
        }));
      }

      if(actionMode === 'edit') {
        let newAddressData = {
          _id: addressId,
          description: place.formatted_address,
          loc: [latLng.lng, latLng.lat],
          street,
          city,
          state,
          zip,
          country,
          nearestStore: area,
          apartment
        };
        console.log("NEW_ADDRESS_DATA", newAddressData);
        this.props.dispatch(UserActions.updateUserAddress(newAddressData, response => {
          console.log("UPDATE_ADDRESS_RESPONSE", response);
          if(response.status) this.props.history.goBack();
        }));
      }
    }
  }

  validateDeliveryArea(area) {
    let isDeliveryPermitted = (area !== 'restricted');
    this.setState({
      isDeliveryPermitted: isDeliveryPermitted,
      area
    });

    if(!isDeliveryPermitted) {
      this.setState({showAlert: true, swalParams: {
        title: 'Sorry, We dont deliver here, please choose different location from map or you can search location',
        type: "error",
        showConfirmButton: false
      }})
      setTimeout(() => this.setState({showAlert: false}), 2000);
    }
  }

}

export default connect((state) => {
  return {
    deliveryPlace: state.getIn(['orders', 'deliveryPlace']),
    loading: state.getIn(['orders', 'loading']),
    error: state.getIn(['orders', 'error'])
  };
})(PlacePickerPage);



// WEBPACK FOOTER //
// ./src/containers/commons/PlacePicker.js